export function formatDate(dateString) {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formattedDate = new Date(dateString).toLocaleDateString(undefined, options);
    
    const [month, day, year] = formattedDate.split('/');
    // Rearrange the date parts to the "YYYY-MM-DD" format
    return `${year}-${month}-${day}`;
}